import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module';

const BASIS_TRANSCODER_PATH = `${process.env.BASE_URL || '/'}basis/`;

class Model3DLoader {
  constructor() {
    this.loader = null;
    this.ktx2Loader = null;
    this.supportRenderer = null;
  }

  setSupportRenderer(renderer) {
    if (this.supportRenderer) return;

    this.supportRenderer = renderer;
    this.ktx2Loader?.dispose();
    this.ktx2Loader = null;
    this.loader = null;
  }

  load(url, onProgress) {
    return new Promise((resolve, reject) => {
      this.getLoader().load(
        url,
        (gltf) => resolve(gltf.scene),
        (event) => onProgress?.(event.total ? Math.round((event.loaded / event.total) * 100) : null),
        reject,
      );
    });
  }

  parse(url, buffer) {
    return new Promise((resolve, reject) => {
      const resourcePath = new URL('.', new URL(url, window.location.href)).toString();
      this.getLoader().parse(buffer, resourcePath, (gltf) => resolve(gltf.scene), reject);
    });
  }

  getLoader() {
    if (!this.loader) {
      this.loader = new GLTFLoader()
        .setKTX2Loader(this.createKtx2Loader())
        .setMeshoptDecoder(MeshoptDecoder);
    }

    return this.loader;
  }

  createKtx2Loader() {
    const ktx2Loader = new KTX2Loader().setTranscoderPath(BASIS_TRANSCODER_PATH);
    this.ktx2Loader = ktx2Loader;

    if (this.supportRenderer) return ktx2Loader.detectSupport(this.supportRenderer);

    const temporaryRenderer = new THREE.WebGLRenderer();
    ktx2Loader.detectSupport(temporaryRenderer);
    temporaryRenderer.dispose();
    temporaryRenderer.forceContextLoss();

    return ktx2Loader;
  }
}

export const model3dLoader = new Model3DLoader();
